import { render } from "./menu-item.vue?vue&type=template&id=2dd1c835&scoped=true&ts=true"
import script from "./menu-item.vue?vue&type=script&lang=ts"
export * from "./menu-item.vue?vue&type=script&lang=ts"

import "./menu-item.vue?vue&type=style&index=0&id=2dd1c835&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd1c835"]])

export default __exports__